module.exports = __webpack_public_path__ + "static/media/imgGallery4.9080b75f.jpg";